import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { Currency } from "./currencies";
import { RateSource } from "./rate-source";
import { zCurrency } from "./usd-amounts";

/**
 * Snapshot of a frozen conversion attached to a {@link Money}: the original
 * pre-conversion amount plus optional provenance (which rate source, as of
 * when). Displays and refunds reconvert from this snapshot, never from a live
 * rate. Plain float major units — same representation as `Money.amount`.
 */
export const struckSnapshotSchema_ = z.object({
  amount: z.number(),
  /** Exact conversion rate applied; `amount` remains the summable figure. */
  rate: z.number().optional(),
  // enumName lets this schema be extracted for congodb DDL when embedded in a
  // persisted collection (e.g. FulfillmentGroup's selectedShippingRate.struck).
  currency: zCurrency,
  source: createEnum(RateSource, { enumName: "RateSource" }).optional(),
  asOf: z.number().int().optional(),
});

export const StruckSnapshotSchema: z.ZodType<StruckSnapshot> =
  struckSnapshotSchema_;
export interface StruckSnapshot extends z.infer<typeof struckSnapshotSchema_> {}

/** Frozen conversions keyed by target currency (e.g. a charge's strikes). */
export const StruckMapSchema = z.partialRecord(
  zCurrency,
  struckSnapshotSchema_,
);
export type StruckMap = Partial<Record<Currency, StruckSnapshot>>;
